import React, { FC, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { InfiniteData } from 'react-query';
import PositionBookmarkListItem from '@components/common/positionBookmarkListItem';
import { IPositions } from '@domain/vo/search/PositionVO';
import classnames from 'classnames/bind';
import styles from './positionList.module.scss';

const cx = classnames.bind(styles);

const NoDataArea: FC = () => {
  return (
    <div className={cx('emptyArea')}>
      <strong className={cx('title')}>포지션 정보가 없네요...</strong>
      <p className={cx('text')}>다른 검색어를 입력해 보시겠어요?</p>
    </div>
  );
};

interface IPositionListProps {
  keyword: string;
  data?: InfiniteData<IPositions>;
  onNextPage: () => void;
}

const PositionList: FC<IPositionListProps> = ({ keyword, data, onNextPage }) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      onNextPage();
    }
  }, [inView]);

  const positionEls = data?.pages.map(({ positions }) => {
    return positions.map((item, idx) => (
      <li className={cx('listItem')} key={`${item.sn}_${item.bookmarkYn}`}>
        <PositionBookmarkListItem index={idx} data={item} />
      </li>
    ));
  });

  //리스트 없는 경우
  if (data?.pages[0] && data?.pages[0].positions.length < 1) return <NoDataArea />;

  return (
    <>
      <ul className={cx('positionList')}>{positionEls}</ul>
      {/* Scroll 이벤트용*/}
      <div ref={ref} />
    </>
  );
};

export default PositionList;
